<template>
    <div>
        <v-dialog
            v-model="dialog"
            overlay-opacity="0.7"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            class="col-xs-12 col-sm-12 pb-0 pl-0 pr-0 pt-0 dialog-about"
            max-width="437"
        >
            <!-- eslint-disable vue/no-unused-vars -->
            <template v-slot:activator="{ on }">
            <!-- eslint-enable -->
                <div @click="showDialog">
                    <slot></slot>
                </div>
            </template>

            <v-card class="w-p-32 login-dialog-card">
                <div class="w-card-fullscreen w-font-size-16">
                    <div class="pb-0">
                        <ButtonCloseModal
                            style="margin-bottom: 0 !important"
                            @close="closeButtonModal"
                        ></ButtonCloseModal>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="w-login-form">
                        <LoginForm
                            :referal="referal"
                            :sitekey="sitekey"
                            google-id="603269327615-4d3m95i30espdg9kiehqgho2qph85hag.apps.googleusercontent.com"
                            @close-dialog="closeButtonModal"
                            :next="nextUrl"
                            :skip-captcha="skipCaptcha"
                        />
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import '~/css/shared/vuetify/_dialog.css';

import eventBus from "@/shared/event-bus";

import ButtonCloseModal from "../input/ButtonCloseModal.vue";
import LoginForm from "@/components/auth/LoginForm.vue";

export default {
    props: {
        next: String,
        googleId: String,
        sitekey: String,
        selector: {type: String, default: ''},
        referal: {},
        skipCaptcha: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: {LoginForm, ButtonCloseModal},
    name: "LoginDialog",
    data: () => ({
        dialog: false,
        nextUrl: null
    }),
    created() {
        eventBus.on('openLoginDialog', () => {
            if (!this.dialog) {
                this.dialog = true;
            }
        });

        this.nextUrl = this.next;
    },
    methods: {
        showDialog(e) {
            this.dialog = true;
            e.preventDefault();
        },
        closeButtonModal() {
            this.dialog = false;
        },
        openSignupDialog() {
            this.closeButtonModal();
            eventBus.emit('openSignupDialog');
        },
    },
};
</script>

<style>
.login-dialog-card .w-close-dialog {
    margin-bottom: 0;
}
</style>
